import process from "node:process";
import {
  buildInstallSelfJsonPayload,
  type CliInstallSelfOutcome,
  performManagedInstall,
} from "../local-components/managed-install";

export async function runInstallSelf(input: {
  json: boolean;
  force: boolean;
}): Promise<void> {
  const outcome = await performManagedInstall({ force: input.force });
  if (input.json) {
    process.stdout.write(
      `${JSON.stringify(buildInstallSelfJsonPayload(outcome))}\n`
    );
    return;
  }
  process.stdout.write(formatInstallSelfHuman(outcome));
}

function formatInstallSelfHuman(outcome: CliInstallSelfOutcome): string {
  if (outcome.result === "installed") {
    return `Installed WakeLoop CLI ${outcome.version} at ${outcome.managedBinaryPath} (current: ${outcome.currentPointerPath}).\n`;
  }
  if (outcome.result === "noop_same_version") {
    return `WakeLoop CLI ${outcome.version} is already installed. Nothing to do.\n`;
  }
  return `A newer WakeLoop CLI (${outcome.previousVersion}) is already installed; keeping it. Use --force to install ${outcome.version} anyway.\n`;
}
